import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import plug from '../assets/images/plug.png';
import soundcard from '../assets/images/soundcard.png';
import { useTestState } from '../context/TestContext';

const Soundcard = () => {
  const { dispatch } = useTestState();
  const { t } = useTranslation('soundcard');

  useEffect(() => {
    dispatch({ type: 'UPDATE_PROGRESS', payload: 40 });
  }, [dispatch]);

  return (
    <div className="soundcard">
      <h1 className="top-title-text">{t('top-title')}</h1>
      <div className="main-content">
        <div className="soundcard-item">
          <img src={plug} alt="plug the soundcard in" />
          <p>{t('soundcard')}</p>
        </div>
        <div className="soundcard-item">
          <img src={soundcard} alt="plug headphones into soundcard" />
          <p>{t('soundcard-2')}</p>
        </div>
        <Link to="/environment" className="link-button">
          {t('continue')}
        </Link>
      </div>
    </div>
  );
};

export default Soundcard;
